import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Mail, Send, CheckCircle } from 'lucide-react'
import toast from 'react-hot-toast'

const NewsletterSignup = () => {
  const [isSubscribed, setIsSubscribed] = useState(false)
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  const onSubmit = async (data) => {
    // Store subscription in localStorage
    const subscriptions = JSON.parse(localStorage.getItem('shikdar_films_newsletter') || '[]')
    
    // Check if email already exists
    if (subscriptions.some(sub => sub.email === data.email)) {
      toast.error('This email is already subscribed!')
      return
    }

    subscriptions.push({
      ...data,
      timestamp: new Date().toISOString(),
      id: Date.now()
    })
    localStorage.setItem('shikdar_films_newsletter', JSON.stringify(subscriptions))
    
    setIsSubscribed(true)
    toast.success('Successfully subscribed to our newsletter!')
    reset()

    // Reset success message after 5 seconds
    setTimeout(() => setIsSubscribed(false), 5000)
  }

  return (
    <div className="bg-gradient-to-br from-bengal-green to-bengal-orange rounded-xl p-8 shadow-lg" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="35:4" data-component-id="client/src/components/NewsletterSignup.jsx:35:4">
      <div className="flex items-center gap-3 mb-4" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="36:6" data-component-id="client/src/components/NewsletterSignup.jsx:36:6">
        <Mail className="w-8 h-8 text-white" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="37:8" data-component-id="client/src/components/NewsletterSignup.jsx:37:8" />
        <h3 className="text-2xl font-bold text-white section-title" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="38:8" data-component-id="client/src/components/NewsletterSignup.jsx:38:8">Stay Updated</h3>
      </div>
      <p className="text-white/90 mb-6" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="40:6" data-component-id="client/src/components/NewsletterSignup.jsx:40:6">
        Subscribe to our newsletter for updates on new releases and casting calls
      </p>

      {isSubscribed ? (
        <div className="flex items-center gap-3 bg-white/20 backdrop-blur-sm rounded-lg p-4" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="45:8" data-component-id="client/src/components/NewsletterSignup.jsx:45:8">
          <CheckCircle className="w-6 h-6 text-white" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="46:10" data-component-id="client/src/components/NewsletterSignup.jsx:46:10" />
          <span className="text-white font-medium" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="47:10" data-component-id="client/src/components/NewsletterSignup.jsx:47:10">Thank you for subscribing!</span>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col sm:flex-row gap-3" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="50:8" data-component-id="client/src/components/NewsletterSignup.jsx:50:8">
          <div className="flex-1" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="51:10" data-component-id="client/src/components/NewsletterSignup.jsx:51:10">
            <input
              type="email"
              {...register('email', { 
                required: 'Email is required',
                pattern: { 
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 
                  message: 'Invalid email address' 
                }
              })}
              placeholder="Enter your email"
              className="w-full px-4 py-3 rounded-lg focus:ring-2 focus:ring-white focus:outline-none"
              data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="52:12" data-component-id="client/src/components/NewsletterSignup.jsx:52:12"
            />
            {errors.email && (
              <p className="mt-1 text-sm text-white" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="65:14" data-component-id="client/src/components/NewsletterSignup.jsx:65:14">{errors.email.message}</p>
            )}
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 bg-white text-bengal-green hover:bg-gray-100 font-semibold px-6 h-12 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 whitespace-nowrap"
            data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="69:10" data-component-id="client/src/components/NewsletterSignup.jsx:69:10"
          >
            <Send className="w-5 h-5" data-component-path="client/src/components/NewsletterSignup.jsx" data-component-line="73:12" data-component-id="client/src/components/NewsletterSignup.jsx:73:12" />
            Subscribe
          </button>
        </form>
      )}
    </div>
  )
}

export default NewsletterSignup